'use client';

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('612853cb2e9028a45409a6f2b5f082eeTz03MTcyMyxFPTE3MjIyMzgyOTAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

export default function MuiXLicense() {
  return null;
}
